import React from 'react'

const context = process.env.PUBLIC_URL

export default function ErrorService({ errorMessage }: { errorMessage?: string | undefined }) {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-20">
            <img 
                alt="Error en el servicio" 
                className="opacity-75 mb-8" 
                style={{height: '300px'}} 
                src={`${context}/img/error_servicio.png`}
            />
            <div className="text-center">
                <h1 className="text-3xl font-bold text-gray-800 mb-4">
                    Error en el servicio
                </h1>
                <p className="text-lg text-gray-600 mb-6">
                    Lo sentimos, ha ocurrido un error al conectar con el servicio.
                </p>
                {errorMessage && (
                    <p className="text-base text-red-600 mb-4 font-semibold">
                        {errorMessage}
                    </p>
                )}
                <p className="text-sm text-gray-500">
                    Por favor, intenta nuevamente más tarde.
                </p>
            </div>
        </div>
    )
}

